import { useState, useEffect } from 'react';
import { Link as RouterLink, Navigate, useNavigate } from 'react-router-dom';
// material
import { styled } from '@mui/material/styles';
import { Box, Button, Container, Typography } from '@mui/material';
// layouts
import LogoOnlyLayout from '../../layouts/LogoOnlyLayout';
// routes
import { PATH_AUTH } from '../../routes/paths';
// components
import Page from '../../components/Page';
import { NewPasswordForm } from '../../components/authentication/new-password';
//
// import { SentIcon } from '../../assets';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  display: 'flex',
  minHeight: '100%',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}));

// ----------------------------------------------------------------------

export default function ResetPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const navigate = useNavigate();

  return (
    <RootStyle title="Reset Password">
      <LogoOnlyLayout />

      <Container>
        <Box sx={{ maxWidth: 480, mx: 'auto' }}>
          {!sent ? (
            <>
              <Typography variant="h3" paragraph>
                Crea una nueva contraseña
              </Typography>
              <Typography sx={{ color: 'text.secondary', mb: 5 }}>
                Escribe la nueva contraseña que estará asociada a tu cuenta
              </Typography>

              <NewPasswordForm
                onSent={() => setSent(true)}
                onGetEmail={(value) => setEmail(value)}
              />

              <Button
                fullWidth
                size="large"
                component={RouterLink}
                to={PATH_AUTH.login}
                sx={{ mt: 1 }}
              >
                Atrás
              </Button>
            </>
          ) : (
            <Box sx={{ textAlign: 'center' }}>
              {/* <SentIcon sx={{ mb: 5, mx: 'auto', height: 160 }} /> */}

              <Typography variant="h3" gutterBottom>
                Solicitud mandada con éxito
              </Typography>
              <Typography>
                Hemos restablecido la contraseña para el usuario &nbsp;
                <strong>{email}</strong>
              </Typography>

              <Button
                size="large"
                variant="contained"
                component={RouterLink}
                to={PATH_AUTH.login}
                sx={{ mt: 5 }}
              >
                Atrás
              </Button>
            </Box>
          )}
        </Box>
      </Container>
    </RootStyle>
  );
}
